import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { activeNote, startDeleting } from '../../actions/notes'
import { useForm } from '../../hooks/useForm'
import { NotesAppBar } from './NotesAppBar'

export const NoteScreen = () => {
   const dispatch = useDispatch();
   const { active: note } = useSelector(state => state.notes)
   const [formValues, handleInputChange, reset] = useForm(note);
   const { body, title, url, id } = formValues;

   const activeId = useRef(note.id);
   const activeUrl = useRef(note.Url);
   useEffect(() => {
      if (note.id !== activeId.current) {
         reset(note);
         activeId.current = note.id;
      }
      if (note.url !== activeUrl.current) {
         reset(note);
         activeUrl.current = note.url;
      }

   }, [note, reset])

   useEffect(() => {
      dispatch(activeNote(formValues.id, { ...formValues }))
   }, [formValues, dispatch])


   const handleDelete = () => {
      dispatch(startDeleting(id));
   }
   return (
      <div className='notes__main-content'>
         <NotesAppBar />
         <div className='notes__content'>
            <input
               type="text"
               name='title'
               placeholder='Some awesome title'
               className='notes__title-input'
               autoComplete='off'
               value={title}
               onChange={handleInputChange}
            />
            <textarea
               placeholder='What happened today'
               className='notes__textarea'
               name='body'
               value={body}
               onChange={handleInputChange}></textarea>
            {
               (url)
               &&
               (<div className='notes__image'>
                  <img src={url}
                     alt='pikachu' />
               </div>)
            }
         </div>

         <button className='btn btn-danger' onClick={handleDelete}>
            Delete
         </button>
      </div>
   )
}
